module.exports = window.VuexRouterSync;